import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
// eslint-disable-next-line no-shadow
export var UnitType;
(function (UnitType) {
    UnitType["GALLONS"] = "gallons";
    UnitType["CUBIC_FEET"] = "cubic_feet";
    UnitType["CUBIC_METERS"] = "cubic_meters";
    UnitType["LITERS"] = "liters";
})(UnitType || (UnitType = {}));
var UnitService = /** @class */ (function () {
    function UnitService() {
        this.units = {
            gallons: {
                type: UnitType.GALLONS,
                name: 'Gallons',
                short: 'gal',
                query: 'GALLONS',
                mult: 1.0,
                convert: this.unitConvertFn(UnitType.GALLONS),
            },
            cubic_feet: {
                type: UnitType.CUBIC_FEET,
                name: 'Cubic Feet',
                short: 'cu ft',
                query: 'CUBIC_FEET',
                mult: 0.133681,
                convert: this.unitConvertFn(UnitType.CUBIC_FEET),
            },
            cubic_meters: {
                type: UnitType.CUBIC_METERS,
                name: 'Cubic Meters',
                short: 'cm',
                query: 'CUBIC_METERS',
                mult: 0.00378541,
                convert: this.unitConvertFn(UnitType.CUBIC_METERS),
            },
            liters: {
                type: UnitType.LITERS,
                name: 'Liters',
                short: 'L',
                query: 'LITERS',
                mult: 3.78541,
                convert: this.unitConvertFn(UnitType.LITERS),
            },
        };
        this.current = new BehaviorSubject(UnitType.GALLONS);
        this.localStorageName = 'unit';
        var stored = localStorage.getItem(this.localStorageName);
        if (this.units[stored]) {
            this.current.next(stored);
        }
        else {
            localStorage.setItem(this.localStorageName, this.current.value.toString());
        }
    }
    Object.defineProperty(UnitService.prototype, "onChange", {
        get: function () {
            return this.current.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    UnitService.prototype.convertUnits = function (amount, from, to) {
        return (amount / this.units[from].mult) * this.units[to].mult;
    };
    UnitService.prototype.convertFromCurrent = function (amount, unit) {
        return this.convertUnits(amount, unit, this.current.value);
    };
    UnitService.prototype.convertToCurrent = function (amount, unit) {
        return this.convertUnits(amount, unit, this.current.value);
    };
    UnitService.prototype.convertFromGallonsToCurrent = function (amount) {
        return this.convertUnits(amount, UnitType.GALLONS, this.current.value);
    };
    UnitService.prototype.convertFromCurrentToGallons = function (amount) {
        return this.convertUnits(amount, this.current.value, UnitType.GALLONS);
    };
    UnitService.prototype.get = function () {
        return this.units[this.current.value];
    };
    UnitService.prototype.set = function (unit) {
        this.current.next(unit);
        localStorage.setItem(this.localStorageName, unit.toString().toLowerCase());
    };
    UnitService.prototype.getAll = function () {
        return Object.values(this.units);
    };
    UnitService.prototype.unitConvertFn = function (unit) {
        var _this = this;
        return (function (amt, from) { return _this.convertUnits(amt, from, unit); }).bind(this);
    };
    UnitService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnitService_Factory() { return new UnitService(); }, token: UnitService, providedIn: "root" });
    return UnitService;
}());
export { UnitService };
